// src/services/three-teardown.ts
import * as THREE from 'three';

export function disposeObject3D(object: THREE.Object3D) {
  object.traverse((o: any) => {
    // geometries
    if (o.geometry?.dispose) o.geometry.dispose();

    // materials + alle textures in het materiaal
    const materials = Array.isArray(o.material)
      ? o.material
      : o.material
      ? [o.material]
      : [];

    for (const m of materials) {
      for (const k in m) {
        const v = (m as any)[k];
        if (v && v.isTexture && v.dispose) v.dispose();
      }
      m.dispose?.();
    }
  });
}

export function teardownThree(opts: {
  renderer?: THREE.WebGLRenderer | null;
  scene?: THREE.Scene | null;
  requestId?: number | null;
  controls?: { dispose?: () => void } | null;
}) {
  const { renderer, scene, requestId, controls } = opts;

  // 1) animatieloop stoppen
  if (renderer?.setAnimationLoop) renderer.setAnimationLoop(null);
  if (requestId) cancelAnimationFrame(requestId);

  // 2) controls / listeners
  controls?.dispose?.();

  // 3) scene assets
  if (scene) disposeObject3D(scene);

  // 4) WebGL context hard sluiten (stabiliseert Windows-drivers)
  try {
    const gl = renderer?.getContext?.();
    const lose = gl?.getExtension?.('WEBGL_lose_context');
    lose?.loseContext?.();
  } catch(e) {console.log(e)}

  // 5) renderer cleanup
  renderer?.dispose?.();

  // 6) cache leeg
  THREE.Cache?.clear?.();
}
